import React, { useEffect, useState, useRef } from 'react';
import Slider from "react-slick";
import plan_top from '../images/plan-top.png'
import plan_top_org from '../images/plan-top-or.png'
import '../css/PackagePage.css';

const PackagePage = () => {
    const [activeButton, setActiveButton] = useState('buy'); // Default active button

    const handleButtonClick = (buttonName) => {
        setActiveButton(buttonName);
    };

    const [validityButton, setValidityButton] = useState('45'); // Default active button

    const handleButtonClick1 = (buttonName) => {
        setValidityButton(buttonName);
    }
    const [isHovered, setIsHovered] = useState(false);
    const [isHovered1, setIsHovered1] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const [isHovered3, setIsHovered3] = useState(false);




    // Subscribe
    const feature = {
        arrows: false,
        centerMode: false,
        dots: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<',
        nextArrow: '>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: false, /* Disable arrows for smaller screens */
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    };



    return (
        <div className='container package_container'>
            <div className='package_page_section'>
                <h1 className='package_page_h1'>Choose the right plan for you</h1>


                <div className='container'>
                    <table className='w-100 desk'>
                        <thead className='package-header'>
                            <tr>
                                <td className='valignbotm w-20'>
                                    <button className={`package_button ${activeButton === 'buy' ? 'active' : ''}`} onClick={() => handleButtonClick('buy')}>BUY</button>
                                    <button className={`package_button ${activeButton === 'rent' ? 'active' : ''}`} onClick={() => handleButtonClick('rent')}>RENT</button>
                                </td>
                                <td className='valignbotm w-20'>
                                    <div className='package_plan_validity'>
                                        <p>Change Plan Validity</p>
                                        <div className="toggle-container">
                                            <button className={`toggle-btn ${validityButton === '45' ? 'active' : ''}`} onClick={() => handleButtonClick1('45')}>45 Days</button>
                                            <button className={`toggle-btn ${validityButton === '90' ? 'active' : ''}`} onClick={() => handleButtonClick1('90')}>90 Days</button>
                                        </div>
                                    </div>
                                </td>
                                <td className='valignbotm w-12 ovhid'>
                                    <div className='package-header-detail'>
                                        <div className='package-header-div'  >
                                            <p>Starter</p>
                                        </div>
                                        <img src={plan_top} className='img-fluid w-100' alt="DreamSakha" />
                                    </div>
                                </td>
                                <td className='w-1'></td>
                                <td className='valignbotm w-12 ovhid'>
                                    <div className='package-header-detail'>
                                        <div className='package-header-div' >
                                            <p>Basic</p>
                                        </div>
                                        <img src={plan_top} className='img-fluid w-100' alt="DreamSakha" />
                                    </div>
                                </td>
                                <td className='w-1'></td>
                                <td className='valignbotm w-12 ovhid'>
                                    <div className='package-header-detail'>
                                        <div className='package-header-div' >
                                            <p>Professional</p>
                                        </div>
                                        <img src={plan_top_org} className='img-fluid w-100' alt="DreamSakha" />
                                    </div>
                                </td>
                                <td className='w-1'></td>
                                <td className='valignbotm w-12 ovhid'>
                                    <div className='package-header-detail'>
                                        <div className='package-header-div' >
                                            <p>Premium</p>
                                        </div>
                                        <img src={plan_top} className='img-fluid w-100' alt="DreamSakha" />
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody className='package-body'>
                            <tr>
                                <td colspan="2" className='fstcol'>
                                    <h1 className='package-body-userName'>Hey Ishita Roy,</h1>
                                    <p className='package-body-p'>Subscribe to Premium today to save 50,000 on brokerage, along with other benefits.</p>
                                    <div className='pkgtimer d-flex gap-3'>
                                        <p className='package-body-timer mb-0'>14:35</p>
                                        <p className='package-body-timer-p mb-0'>Hurry..! Purchase A Plan Before Your Exclusive Discount Expires!</p>
                                    </div>
                                </td>
                                <td className='package-price-detail'>
                                    <div>
                                        <p className='package-price-detail1' >₹1198</p>
                                        <p className='package-price-detail2'>₹599/-</p>
                                        <p className='package-price-detail3'>+ 18% GST
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2588_36)">
                                                    <path d="M5.00049 8.75C7.07156 8.75 8.75049 7.07107 8.75049 5C8.75049 2.92893 7.07156 1.25 5.00049 1.25C2.92942 1.25 1.25049 2.92893 1.25049 5C1.25049 7.07107 2.92942 8.75 5.00049 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5.00049 4.58301V7.08301" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4.89648 3.33366V2.91699H5.10482V3.33366H4.89648Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2588_36">
                                                        <rect width="10" height="10" fill="white" transform="translate(0.000488281)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                        </p>
                                    </div>
                                </td>
                                <td></td>
                                <td className='package-price-detail'>
                                    <div>
                                        <p className='package-price-detail1' >₹1598</p>
                                        <p className='package-price-detail2'>₹799/-</p>
                                        <p className='package-price-detail3'>+ 18% GST
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2588_36)">
                                                    <path d="M5.00049 8.75C7.07156 8.75 8.75049 7.07107 8.75049 5C8.75049 2.92893 7.07156 1.25 5.00049 1.25C2.92942 1.25 1.25049 2.92893 1.25049 5C1.25049 7.07107 2.92942 8.75 5.00049 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5.00049 4.58301V7.08301" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4.89648 3.33366V2.91699H5.10482V3.33366H4.89648Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2588_36">
                                                        <rect width="10" height="10" fill="white" transform="translate(0.000488281)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </p>
                                    </div>
                                </td>
                                <td></td>
                                <td className='package-price-detail'>
                                    <div>
                                        <p className='package-price-detail1' >₹2198</p>
                                        <p className='package-price-detail2'>₹1099/-</p>
                                        <p className='package-price-detail3'>+ 18% GST
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2588_36)">
                                                    <path d="M5.00049 8.75C7.07156 8.75 8.75049 7.07107 8.75049 5C8.75049 2.92893 7.07156 1.25 5.00049 1.25C2.92942 1.25 1.25049 2.92893 1.25049 5C1.25049 7.07107 2.92942 8.75 5.00049 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5.00049 4.58301V7.08301" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4.89648 3.33366V2.91699H5.10482V3.33366H4.89648Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2588_36">
                                                        <rect width="10" height="10" fill="white" transform="translate(0.000488281)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                        </p>
                                    </div>
                                </td>
                                <td></td>
                                <td className='package-price-detail'>
                                    <div>
                                        <p className='package-price-detail1' >₹3298</p>
                                        <p className='package-price-detail2'>₹1649/-</p>
                                        <p className='package-price-detail3'>+ 18% GST
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2588_36)">
                                                    <path d="M5.00049 8.75C7.07156 8.75 8.75049 7.07107 8.75049 5C8.75049 2.92893 7.07156 1.25 5.00049 1.25C2.92942 1.25 1.25049 2.92893 1.25049 5C1.25049 7.07107 2.92942 8.75 5.00049 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5.00049 4.58301V7.08301" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4.89648 3.33366V2.91699H5.10482V3.33366H4.89648Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2588_36">
                                                        <rect width="10" height="10" fill="white" transform="translate(0.000488281)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                        </p>
                                    </div>
                                </td>
                                {/* <td className='lastblankcol'></td> */}
                            </tr>
                            <tr>
                                <td colspan="2" className='pkjrowbx'>
                                    <p className='package-body-left-p fstcol'>Zero Brokerage owners contacts</p>
                                </td>
                                <td className='bgblue pkjrowwtbx'>
                                    <p className=' package-body-right-p'>5</p>
                                </td>
                                <td></td>
                                <td className='bgblue pkjrowwtbx'>
                                    <p className=' package-body-right-p'>15</p>
                                </td>
                                <td></td>
                                <td className='bgorange pkjrowwtbx'>
                                    <p className=' package-body-right-p'>25</p>
                                </td>
                                <td></td>
                                <td className='bgblue pkjrowwtbx'>
                                    <p className=' package-body-right-p'>50</p>
                                </td>
                                {/* <td className='lastblankcol'></td> */}
                            </tr>
                            <tr>
                                <td colspan="2" className='pkjrowbx'>
                                    <p className='package-body-left-p fstcol'>Priority Customer support</p>
                                </td>
                                <td className='bgblue pkjrowwtbx'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                    </p>
                                </td>
                                <td></td>
                                <td className='bgblue pkjrowwtbx'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </p>
                                </td>
                                <td></td>
                                <td className='bgorange pkjrowwtbx'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </p>
                                </td>
                                <td></td>
                                <td className='bgblue pkjrowwtbx'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </p>
                                </td>
                                {/* <td className='lastblankcol'></td> */}
                            </tr>
                            <tr>
                                <td colspan="2" className='pkjrowbx fstcol'>
                                    <p className='package-body-left-p'>Instant alerts on new properties</p>
                                </td>
                                <td className='bgblue pkjrowwtbx'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                    </p>
                                </td>
                                <td></td>
                                <td className='bgblue pkjrowwtbx'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </p>
                                </td>
                                <td></td>
                                <td className='bgorange pkjrowwtbx'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </p>
                                </td>
                                <td></td>
                                <td className='bgblue pkjrowwtbx'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </p>
                                </td>
                                {/* <td className='lastblankcol'></td> */}
                            </tr>
                            <tr>
                                <td colspan="2" className='pkjrowbx'>
                                    <p className='package-body-left-p fstcol'>Dedicated relationship manager</p>
                                </td>
                                <td className='bgblue'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                    </p>
                                </td>
                                <td></td>
                                <td className='bgblue'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                    </p>
                                </td>
                                <td></td>
                                <td className='bgorange'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                    </p>
                                </td>
                                <td></td>
                                <td className='bgblue'>
                                    <p className='package-body-right-p'>
                                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </p>
                                </td>
                                {/* <td className='lastblankcol'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td> */}
                            </tr>
                            <tr>
                                <td colspan="2">&nbsp;</td>
                                <td>
                                    <button className="bgbluebtn w-100" onClick=''>
                                        BUY
                                    </button>
                                </td>
                                <td></td>
                                <td>
                                    <button className="bgbluebtn w-100" onClick=''>
                                        BUY
                                    </button>
                                </td>
                                <td></td>
                                <td>
                                    <button className="bgorangebtn w-100" onClick=''>
                                        BUY
                                    </button>
                                </td>
                                <td></td>
                                <td>
                                    <button className="bgbluebtn w-100" onClick=''>
                                        BUY
                                    </button>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan='9' className='lastblankrow'></td>
                            </tr>
                        </tbody>
                    </table>

                    <table className='w-100 mob'>
                        <thead className='package-header'>
                            <tr>
                                <td colspan="2" className='w-100'>
                                    <h1 className='package-body-userName'>Hey Ishita Roy,</h1>
                                    <p className='package-body-p'>Subscribe to Premium today to save 50,000 on brokerage, along with other benefits.</p>
                                    <div className='pkgtimer d-flex gap-3'>
                                        <p className='package-body-timer mb-0'>14:35</p>
                                        <p className='package-body-timer-p mb-0'>Hurry..! Purchase A Plan Before Your Exclusive Discount Expires!</p>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='valignbotm w-50'>
                                    <button className={`package_button ${activeButton === 'buy' ? 'active' : ''}`} onClick={() => handleButtonClick('buy')}>BUY</button>
                                    <button className={`package_button ${activeButton === 'rent' ? 'active' : ''}`} onClick={() => handleButtonClick('rent')}>RENT</button>
                                </td>
                                <td className='valignbotm w-50'>
                                    <div className='package_plan_validity'>
                                        <p>Change Plan Validity</p>
                                        <div className="toggle-container">
                                            <button className={`toggle-btn ${validityButton === '45' ? 'active' : ''}`} onClick={() => handleButtonClick1('45')}>45 Days</button>
                                            <button className={`toggle-btn ${validityButton === '90' ? 'active' : ''}`} onClick={() => handleButtonClick1('90')}>90 Days</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" className='w-100'>

                                    <div className='subsoutbx'>
                                        <h5>STARTER</h5>
                                        <div className='subsinerbx'>
                                            <div className='subsinerdatabx'>
                                                <p>Zero Brokerage owners contacts</p>
                                                <div className='subsdatares'>5</div>
                                            </div>
                                            <div className='subsinerdatabx'>
                                                <p>Priority Customer support</p>
                                                <div className='subsdatares'>
                                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66026 9.5L5.51758 12.6427L6.35727 13.4824L9.49998 10.3397L12.6427 13.4824L13.4824 12.6427L10.3397 9.5L13.4823 6.35739L12.6426 5.5177L9.49998 8.66028L6.35736 5.5177L5.51767 6.35739L8.66026 9.5Z" fill="white" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className='subsinerdatabx'>
                                                <p>Instant alerts on new properties</p>
                                                <div className='subsdatares'>
                                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66026 9.5L5.51758 12.6427L6.35727 13.4824L9.49998 10.3397L12.6427 13.4824L13.4824 12.6427L10.3397 9.5L13.4823 6.35739L12.6426 5.5177L9.49998 8.66028L6.35736 5.5177L5.51767 6.35739L8.66026 9.5Z" fill="white" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className='subsinerdatabx'>
                                                <p>Dedicated relationship manager</p>
                                                <div className='subsdatares'>
                                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.66026 9.5L5.51758 12.6427L6.35727 13.4824L9.49998 10.3397L12.6427 13.4824L13.4824 12.6427L10.3397 9.5L13.4823 6.35739L12.6426 5.5177L9.49998 8.66028L6.35736 5.5177L5.51767 6.35739L8.66026 9.5Z" fill="white" />
                                                    </svg>
                                                </div>
                                            </div>

                                            <div className='subsinerdatabx pricebx'>
                                                <p class="package-price-detail1">₹1198</p>
                                                <p class="package-price-detail2">₹599/-</p>
                                                <p class="package-price-detail3">+ 18% GST<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2588_36)"><path d="M5.00049 8.75C7.07156 8.75 8.75049 7.07107 8.75049 5C8.75049 2.92893 7.07156 1.25 5.00049 1.25C2.92942 1.25 1.25049 2.92893 1.25049 5C1.25049 7.07107 2.92942 8.75 5.00049 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.00049 4.58301V7.08301" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.89648 3.33366V2.91699H5.10482V3.33366H4.89648Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_2588_36"><rect width="10" height="10" fill="white" transform="translate(0.000488281)"></rect></clipPath></defs></svg></p>
                                            </div>

                                        </div>
                                        <button className='bgbluebtn w-100'>BUY</button>
                                    </div>


                                    {/* <Slider {...feature}>

                                        <div className="featureslides">

                                            <div className="fslidebox">

                                                <div className="featurebox">ok</div>
                                                <div className="overlaydata">
                                                    feature name----1
                                                </div>
                                            </div>

                                        </div>

                                    </Slider> */}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>







                {/* <div className='container  mb-5'>
                    <div className='package-header'>
                        <div className='row'>
                            <div className='col-md-5 d-flex justify-content-between align-items-end'>
                                <div className='package-buttons'>
                                    <button className={`package_button ${activeButton === 'buy' ? 'active' : ''}`} onClick={() => handleButtonClick('buy')}>BUY</button>
                                    <button className={`package_button ${activeButton === 'rent' ? 'active' : ''}`} onClick={() => handleButtonClick('rent')}>RENT</button>
                                </div>
                                <div className='package_plan_validity' style={{ marginBottom: '-8px' }}>
                                    <p>Change Plan Validity</p>
                                    <div className="toggle-container">
                                        <button className={`toggle-btn ${validityButton === '45' ? 'active' : ''}`} onClick={() => handleButtonClick1('45')}>45 Days</button>
                                        <button className={`toggle-btn ${validityButton === '90' ? 'active' : ''}`} onClick={() => handleButtonClick1('90')}>90 Days</button>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-7 d-flex justify-content-between'>
                                <div className='package-header-detail'>
                                    <div className='package-header-div'  >
                                        <p>Starter</p>
                                    </div>
                                    <img src={plan_top} alt="DreamSakha" />
                                </div>
                                <div className='package-header-detail'>
                                    <div className='package-header-div' >
                                        <p>Basic</p>
                                    </div>
                                    <img src={plan_top} alt="DreamSakha" />
                                </div>
                                <div className='package-header-detail'>
                                    <div className='package-header-div' >
                                        <p>Professional</p>
                                    </div>
                                    <img src={plan_top_org} alt="DreamSakha" />
                                </div>
                                <div className='package-header-detail'>
                                    <div className='package-header-div' >
                                        <p>Premium</p>
                                    </div>
                                    <img src={plan_top} alt="DreamSakha" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='package-body'>
                        <div className='row'>
                            <div className='col-md-5 package-body-left'>
                                <div>
                                    <h1 className='package-body-userName'>Hey Ishita Roy,</h1>
                                    <p className='package-body-p'>Subscribe to Premium today to save 50,000 on brokerage, along with other benefits.</p>
                                    <div className='d-flex gap-3'>
                                        <p className='package-body-timer'>14:35</p>
                                        <p className='package-body-timer-p'>Hurry..! Purchase A Plan Before Your Exclusive Discount Expires!</p>
                                    </div>
                                </div>
                                <p className='package-body-alert'>*Please check the Offer details here</p>
                                <div className='package-condition'>
                                    <p className='package-body-left-p1'>Zero Brokerage owners contacts</p>
                                    <p className='package-body-left-p'>Priority Customer support</p>
                                    <p className='package-body-left-p'>Instant alerts on new properties</p>
                                    <p className='package-body-left-p4'>Dedicated relationship manager</p>
                                </div>
                            </div>
                            <div className='col-md-7 package-body-right'>
                                <div className='package-body-right-span starter_package' style={{ marginBottom: '30px' }} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                                    <div className='package-price-detail'>
                                        <p className='package-price-detail1' >₹1198</p>
                                        <p className='package-price-detail2'>₹599/-</p>
                                        <p className='package-price-detail3'>+ 18% GST
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2588_36)">
                                                    <path d="M5.00049 8.75C7.07156 8.75 8.75049 7.07107 8.75049 5C8.75049 2.92893 7.07156 1.25 5.00049 1.25C2.92942 1.25 1.25049 2.92893 1.25049 5C1.25049 7.07107 2.92942 8.75 5.00049 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5.00049 4.58301V7.08301" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4.89648 3.33366V2.91699H5.10482V3.33366H4.89648Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2588_36">
                                                        <rect width="10" height="10" fill="white" transform="translate(0.000488281)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                        </p>
                                    </div>
                                    <div>
                                        <p className=' package-body-right-p  property_posted'>5</p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div className='buy_button'>
                                        <p className='package-body-right-last-p'>
                                            BUY
                                        </p>
                                    </div>
                                </div>
                                <div className='package-body-right-span basic_package' style={{ marginBottom: '30px' }} onMouseEnter={() => setIsHovered1(true)} onMouseLeave={() => setIsHovered1(false)}>
                                    <div className='package-price-detail'>
                                        <p className='package-price-detail1' >₹1598</p>
                                        <p className='package-price-detail2'>₹799/-</p>
                                        <p className='package-price-detail3'>+ 18% GST
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2588_36)">
                                                    <path d="M5.00049 8.75C7.07156 8.75 8.75049 7.07107 8.75049 5C8.75049 2.92893 7.07156 1.25 5.00049 1.25C2.92942 1.25 1.25049 2.92893 1.25049 5C1.25049 7.07107 2.92942 8.75 5.00049 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5.00049 4.58301V7.08301" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4.89648 3.33366V2.91699H5.10482V3.33366H4.89648Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2588_36">
                                                        <rect width="10" height="10" fill="white" transform="translate(0.000488281)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                        </p>
                                    </div>
                                    <div>
                                        <p className=' package-body-right-p property_posted'>15</p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div className='buy_button'>
                                        <p className='package-body-right-last-p'>
                                            BUY
                                        </p>
                                    </div>
                                </div>
                                <div className='package-body-right-span professional-package' style={{ marginBottom: '30px' }} onMouseEnter={() => setIsHovered2(true)} onMouseLeave={() => setIsHovered2(false)}>
                                    <div className='package-price-detail'>
                                        <p className='package-price-detail1' >₹2198</p>
                                        <p className='package-price-detail2'>₹1099/-</p>
                                        <p className='package-price-detail3'>+ 18% GST
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2588_36)">
                                                    <path d="M5.00049 8.75C7.07156 8.75 8.75049 7.07107 8.75049 5C8.75049 2.92893 7.07156 1.25 5.00049 1.25C2.92942 1.25 1.25049 2.92893 1.25049 5C1.25049 7.07107 2.92942 8.75 5.00049 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5.00049 4.58301V7.08301" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4.89648 3.33366V2.91699H5.10482V3.33366H4.89648Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2588_36">
                                                        <rect width="10" height="10" fill="white" transform="translate(0.000488281)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                        </p>
                                    </div>
                                    <div>
                                        <p className=' package-body-right-p property_posted'>25</p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2324 20L11.6162 26.6162L13.384 28.384L20.0002 21.7678L26.6164 28.384L28.3842 26.6162L21.768 20L28.384 13.384L26.6162 11.6162L20.0002 18.2322L13.3842 11.6162L11.6164 13.384L18.2324 20Z" fill="white" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div className='buy_button'>
                                        <p className='package-body-right-last-p'>
                                            BUY
                                        </p>
                                    </div>
                                </div>
                                <div className='package-body-right-span premium_pakage' style={{ marginBottom: '30px' }} onMouseEnter={() => setIsHovered3(true)} onMouseLeave={() => setIsHovered3(false)}>
                                    <div className='package-price-detail'>
                                        <p className='package-price-detail1' >₹3298</p>
                                        <p className='package-price-detail2'>₹1649/-</p>
                                        <p className='package-price-detail3'>+ 18% GST
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_2588_36)">
                                                    <path d="M5.00049 8.75C7.07156 8.75 8.75049 7.07107 8.75049 5C8.75049 2.92893 7.07156 1.25 5.00049 1.25C2.92942 1.25 1.25049 2.92893 1.25049 5C1.25049 7.07107 2.92942 8.75 5.00049 8.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5.00049 4.58301V7.08301" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4.89648 3.33366V2.91699H5.10482V3.33366H4.89648Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2588_36">
                                                        <rect width="10" height="10" fill="white" transform="translate(0.000488281)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                        </p>
                                    </div>
                                    <div>
                                        <p className=' package-body-right-p property_posted'>50</p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div>
                                        <p className='package-body-right-p'><svg width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.7998 20.7996L16.267 27.9996L31.1998 13.5996" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        </p>
                                    </div>
                                    <div className='buy_button'>
                                        <p className='package-body-right-last-p'>
                                            BUY
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default PackagePage


